<template>
    <div :class="containerClass">

        <ul>

            <li v-for="(article, index) in posts"
                class="post"
                @click="openPost('post_' + index, article.url, article)"
            >
                <a>
                    <div class="post">

                        <div class="imageWrap">
                            <div class="imageInner"
                                 v-if="article.thumbnail"
                            >
                                <img :src="article.thumbnail"
                                     :alt="article.post.post_title"
                                />
                            </div>
                        </div> <!-- .imageWrap -->

                        <div class="innerText">

                            <h2 class="blogTitle" v-html="article.post.post_title" />

                            <div class="blogDate" v-html="article.post_date"></div>

                            <div class="blogExcerpt"
                                 v-html="article.excerpt"
                                 v-if="article.excerpt"
                            ></div>

                        </div> <!-- .innerText -->

                    </div>
                </a>

            </li> <!-- .post -->

        </ul>

    </div> <!-- .posts -->

</template>

<script>
export default {
    props: {
        posts: {
            type: Array,
            required: false,
        },
        containerClass: {
            type: String,
            required: false,
            default: 'posts',
        },
        postsPerPage: {
            type: Number,
            required: false,
        }
    },
    data() {
        return {
            loading: true,
        }
    },
    mounted() {
        this.loading = false
    },
    methods: {
        openPost(index, url, article) {
            window.location.href = url;
        }
    }
}
</script>
